import { KEYS } from '@udecode/plate';

export const getDraftCommentKey = () => `${KEYS.comment}_draft`;
